export enum CitationDisplay {
    hidden = "HIDDEN",
    fileOnly = "FILE_ONLY",
    pagesInfo = "PAGES_INFO",
    pagesLinked = "PAGES_LINKED"
}
